import styled from "styled-components";

const PageContainer = styled.div`
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    background-color: #f4f7fa;
    @media (max-width: 768px) {
        flex-direction: column;  // Stack content for smaller screens
    }
`;

const Sidebar = styled.div`
    width: 240px;
    background-color: #ffffff;
    padding: 20px;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
    @media (max-width: 768px) {
        width: 100%;  // Make sidebar full-width on smaller screens
        box-shadow: none;
        border-bottom: 1px solid #e3e8ed;
    }
`;

const SidebarItem = styled.div`
    margin-bottom: 20px;
    font-size: 1.1rem;
    color: #333;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 6px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #e3e8ed;
    }

    @media (max-width: 768px) {
        font-size: 1rem;
        padding: 8px 10px;
    }
`;

const ContentContainer = styled.div`
    flex-grow: 1;
    padding: 40px;
    @media (max-width: 1200px) {
        padding: 30px;  // Reduce padding slightly on smaller wide screens
    }
    @media (max-width: 768px) {
        padding: 20px;  // Further reduce padding for smaller screens
    }
`;

const Heading = styled.h1`
    font-size: 2rem;
    color: #333;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

const UploadSection = styled.div`
    border: 2px dashed #ddd;
    padding: 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: border-color 0.3s ease-in-out;

    &:hover {
        border-color: #ccc;
    }

    @media (max-width: 1200px) {
        padding: 15px;
    }

    @media (max-width: 768px) {
        padding: 10px;
        font-size: 0.9rem;  // Adjust font size for smaller screens
    }
`;

const MediaCard = styled.div`
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 16px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    gap: 20px;
    transition: transform 0.2s, box-shadow 0.2s;

    &:active {
        transform: scale(0.98);
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 12px;
        margin-bottom: 16px;
    }
`;

const MediaThumbnail = styled.div`
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const MediaDetails = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 0.95rem;
  }
`;

const LinkControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;

    button, a {
      min-height: 44px;
      padding: 10px 16px;
      font-size: 0.9rem;
    }
  }
`;

const MediaList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 20px;
`;

const FilterSection = styled.div`
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    margin-top: 20px;
    margin-bottom: 20px;
`;

const FilterLabel = styled.label`
    display: block;
    font-size: 0.95rem;
    color: #555;
    margin-bottom: 8px;
    font-weight: 500;
`;

const FilterInputContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
`;

const TagInput = styled.input`
    flex: 1;
    min-width: 200px;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.95rem;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #007bff;
    }
`;

const FilterButton = styled.button`
    padding: 10px 20px;
    background-color: ${props => props.variant === 'secondary' ? '#6c757d' : '#007bff'};
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.95rem;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${props => props.variant === 'secondary' ? '#5a6268' : '#0056b3'};
    }
`;

const ActiveTagsContainer = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 10px;
    flex-wrap: wrap;
`;

const TagChip = styled.span`
    display: inline-block;
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 0.85rem;
    font-weight: 500;
`;

export {
    ActiveTagsContainer,
    ContentContainer,
    FilterButton,
    FilterInputContainer,
    FilterLabel,
    FilterSection,
    Heading,
    LinkControls,
    MediaCard,
    MediaDetails,
    MediaList,
    MediaThumbnail,
    PageContainer,
    Sidebar,
    SidebarItem,
    TagChip,
    TagInput,
    UploadSection
};